import React, { useState } from 'react'
import ReactStars from 'react-rating-stars-component'
import BreadCrum from '../components/BreadCrum'
import Color from '../components/Color'
import Container from '../components/Container'
import Meta from '../components/Meta'
import ProductCard from '../components/ProductCard'

const OurStore = () => {
    const [grid, setGrid] = useState(3);
  return (
    <>
        <Meta title='Our Store'/>
        <BreadCrum title='Store' />
        <Container class1="store-wrapper home-wrapper-2 py-3">
            <div className="row">
                <div className="col-3">
                    <div className="filter-card mb-3">
                        <h3 className="filter-title">Shop By Categories</h3>
                        <div>
                            <ul className="ps-0">
                                <li>Watch</li>
                                <li>Tv</li>
                                <li>Camera</li>
                                <li>Laptop</li>
                            </ul>
                        </div>
                    </div>
                    <div className="filter-card mb-3">
                        <h3 className="filter-title">Filter By</h3>
                        <div>
                            <h5 className="sub-title">Avalibality</h5>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="stock" />
                                <label htmlFor="stock" className="form-check-label">In Stock (1)</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="outofstock" />
                                <label htmlFor="outofstock" className="form-check-label">Out of Stock (0)</label>
                            </div>
                            <h5 className="sub-title">Price</h5>
                            <div className="d-flex align-items-center gap-10">
                                <div className="form-floating">
                                    <input type="text" className="form-control" id="from" placeholder="From" />
                                    <label htmlFor="from">From</label>
                                </div>
                                <div className="form-floating">
                                    <input type="text" className="form-control" id="to" placeholder="To" />
                                    <label htmlFor="to">To</label>
                                </div>
                            </div>
                            <h5 className="sub-title">Colors</h5>
                            <div>
                                <Color />
                            </div>
                            <h5 className="sub-title">Size</h5>
                            <div>
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="small" />
                                    <label htmlFor="small" className="form-check-label">S (1)</label>
                                </div>
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="small" />
                                    <label htmlFor="small" className="form-check-label">M (1)</label>
                                </div>
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="small" />
                                    <label htmlFor="small" className="form-check-label">L (1)</label>
                                </div>
                            </div>   
                        </div>
                    </div>
                    <div className="filter-card mb-3">
                        <h3 className="filter-title">Product Tags</h3>
                        <div>
                            <div className="product-tags d-flex flex-wrap align-items-center">
                                <span className="bg-light text-secondary px-3 py-2 rounded-3">
                                    Headphone    
                                </span>  
                                <span className="bg-light text-secondary px-3 py-2 rounded-3">
                                    Laptop    
                                </span>  
                                <span className="bg-light text-secondary px-3 py-2 rounded-3">
                                    TV    
                                </span>  
                                <span className="bg-light text-secondary px-3 py-2 rounded-3">
                                    Phone    
                                </span>    
                            </div>    
                        </div> 
                    </div>  
                    <div className="filter-card mb-3">
                        <h3 className="filter-title">Random Products</h3>
                        <div>
                            <div className="random-products d-flex mb-3">
                                <div className="w-50">
                                    <img src="images/watch.jpg" className="img-fluid" alt="watch" />
                                </div>
                                <div className="w-50">
                                    <h5>Lorem ipsum dolor sit.</h5>
                                    <ReactStars count={5} value={3} size={24} activeColor="#ffd700" />
                                    <b>$300</b>
                                </div>
                            </div>
                            <div className="random-products d-flex">
                                <div className="w-50">
                                    <img src="images/watch.jpg" className="img-fluid" alt="watch" />
                                </div>
                                <div className="w-50">
                                    <h5>Lorem ipsum dolor sit.</h5>
                                    <ReactStars count={5} value={3} size={24} activeColor="#ffd700" />
                                    <b>$300</b>
                                </div>
                            </div>
                        </div>
                    </div>               
                </div>
                <div className="col-9">
                    <div className="filter-sort-grid">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-10">
                                <p className="mb-0 d-block" style={{ width:'100px' }}>Sort By:</p>
                                <select name="" id="" className="form-control">
                                    <option value="manual">Featured</option>
                                    <option value="best-selling">Best Selling</option>
                                    <option value="title-ascending">Alphabetically, A-Z</option>
                                    <option value="title-descending">Alphabetically, Z-A</option>
                                    <option value="price-ascending">Price, low to hight</option>
                                    <option value="price-descending">Price, hight to low</option>
                                    <option value="created-ascending">Date, old to new</option>
                                    <option value="created-descending">Date, new to old</option>
                                </select>
                            </div>
                            <div className="d-flex align-items-center gap-10">
                                <p className="totalproducts mb-0">21 Products</p>
                                <div className="d-flex align-items-center gap-10 grid">   
                                    <img src="images/gr4.svg" className="d-block img-fluid" alt="grid" onClick={()=>setGrid(3)} />
                                    <img src="images/gr3.svg" className="d-block img-fluid" alt="grid" onClick={()=>setGrid(4)} />
                                    <img src="images/gr2.svg" className="d-block img-fluid" alt="grid" onClick={()=>setGrid(6)} />
                                    <img src="images/gr.svg" className="d-block img-fluid" alt="grid" onClick={()=>setGrid(12)} />
                                </div>                        
                            </div>
                        </div>
                    </div>
                    <div className="product-list pt-3">
                        <div className="d-flex flex-wrap gap-10">
                        <ProductCard grid={grid} />
                        <ProductCard grid={grid} />
                        <ProductCard grid={grid} />
                        <ProductCard grid={grid} />
                        <ProductCard grid={grid} />
                        <ProductCard grid={grid} />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default OurStore